import React from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { connect, useSelector, useDispatch } from "react-redux";
import { Button, ButtonGroup, InputLabel, Switch } from '@material-ui/core';
import { ACTIONS_OF_APROVE, ACTIONS_ON_AFILIATE_RYA, ACTION_AFILIATE_COMPANY, CLOSE_MODALES, DEVOLUCIONES_FORM, DEVOLUCIONES_FORM_NAME, REGISTRO_AND_APORTES_FORM, REGISTRO_AND_APORTES_FORM_NAME, RETURN_HOME_BANDEJA, SEARCH_HISTORIAL_BANDEJA } from "./constants";
import { getDynamicOptions, getIdFormulario, getMessageConfirmationRya } from "./selector";
import Customform from "../../components/materialform/customform";


function Componet({ stepForm, setStepForm, stepFinal, itemsForm, anexos, catalog }) {
    const dispatch = useDispatch();
    const searchHistorial = (value) => dispatch({ type: SEARCH_HISTORIAL_BANDEJA, value });
    const actionsButtonsAprove = (value) => dispatch({ type: ACTIONS_ON_AFILIATE_RYA, value });
    const returnToHome = (value) => dispatch({ type: RETURN_HOME_BANDEJA, value });
    const savedActionsValidation = (value) => dispatch({ type: ACTION_AFILIATE_COMPANY, value });
    const closeModales = (value) => dispatch({ type: CLOSE_MODALES, value });

    const idFormulario = useSelector(getIdFormulario);
    const messageConfirmation = useSelector(getMessageConfirmationRya);
    const dynamicOptions = useSelector(getDynamicOptions);
    const empleadorType = itemsForm && itemsForm.stepPrincipal ? itemsForm.stepPrincipal.afiliacionEmpresas.empleadorTypeCompany : false;

    const modalConfirmacion = () => {
        return (
            <div >
                <Dialog
                    className="modal-confirmation"
                    open
                    scroll={'paper'}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">Información</DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            id="scroll-dialog-description"
                        //tabIndex={-1}
                        >
                            {messageConfirmation.message}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <ButtonGroup color="primary" aria-label="primary button group">
                            <Button
                                onClick={() => closeModales()}
                            >
                                Cancelar
                            </Button>


                            <Button onClick={() => savedActionsValidation({ messageConfirmation, itemsForm, anexos, catalog })}>
                                Aceptar
                            </Button>

                        </ButtonGroup>

                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    return (
        <React.Fragment>
            {messageConfirmation ? modalConfirmacion() : ""}
            {stepFinal && stepFinal === stepForm && empleadorType && empleadorType === "1" ?
                <div className="anulaciones-container">
                    <React.Fragment>
                        <Customform
                        
                            submitable={false}
                            items={REGISTRO_AND_APORTES_FORM}
                            formName={REGISTRO_AND_APORTES_FORM_NAME}
                            className="people-form"
                            dynamicOptions={dynamicOptions}
                        />
                    </React.Fragment>
                </div>
                : ""}
            <div className="devoluciones-container">
                <Button
                    color={"secondary"}
                    type={"submit"}
                    disabled
                    className={"buttonSeeDevoluciones"}
                //onClick={() => openDevolucionesForm(true)}
                //startIcon={ocultaDevoluciones ? <ExpandMoreIcon /> : false}
                >
                    <h3 className="title-devoluciones">Devoluciones</h3>
                </Button>

                <React.Fragment>
                    <Customform
                        submitable={false}
                        items={DEVOLUCIONES_FORM}
                        formName={DEVOLUCIONES_FORM_NAME}
                        className="people-form"
                        dynamicOptions={dynamicOptions}
                    />
                </React.Fragment>

            </div>
            <div className="buttons-container">
                <div className="navega-buttons">
                    <ButtonGroup color="primary" aria-label="primary button group">
                        {stepForm > 0 ?
                            <Button
                                onClick={() => setStepForm(stepForm - 1)}
                            >
                                Atras
                            </Button>
                            : ""}

                        <Button onClick={() => searchHistorial(idFormulario)}>
                            Historial
                        </Button>

                    </ButtonGroup>
                </div>
                <div className="button-wrapper">
                    <ButtonGroup color="primary" aria-label="primary button group">

                        <Button
                            id={"aprove-button"}
                            onClick={() => actionsButtonsAprove({act:"DEVOLVER_COMERCIAL",empleadorType})}
                        >
                            Devolver
                        </Button>

                        {stepFinal && stepFinal === stepForm ?

                            <Button
                                id={"aprove-button"}
                                onClick={() => actionsButtonsAprove({act:"AFILIAR",empleadorType})}
                            >
                                Afiliar
                            </Button>
                            : ""}

                        {stepFinal && stepFinal === stepForm ? "" :
                            <Button onClick={() => setStepForm(stepForm + 1)}>
                                Continuar
                            </Button>
                        }
                        <Button onClick={() => returnToHome()}>
                            Salir
                        </Button>
                    </ButtonGroup>

                </div>
            </div>
        </React.Fragment>
    );
}

export const ComponetRyA = connect(
    null,
    null
)(Componet);